import { render, staticRenderFns } from "./Entity-Preview-Card.vue?vue&type=template&id=2621df2e&lang=pug"
import script from "./Entity-Preview-Card.vue?vue&type=script&setup=true&lang=ts"
export * from "./Entity-Preview-Card.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports